module.exports = "/desktop-app/assets/img/google.png?b0ca08673a5ba4cfdfffa5ce86556aea";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/images/icon/google.png
// module id = xgXH
// module chunks = 1